import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'material-ui/Snackbar';

export default class AppSnackbar extends Component {
  static propTypes = {
    notification: PropTypes.string,
    clearNotification: PropTypes.func.isRequired,
  };

  static defaultProps = {
    notification: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.notification) {
      this.openSnackbar();
    }
  }

  openSnackbar() {
    this.setState({
      open: true,
    });
  }

  handleRequestClose() {
    this.setState({
      open: false,
    });

    this.props.clearNotification();
  }

  render() {
    return (
      <Snackbar
        className="app-snackbar"
        open={this.state.open}
        message={this.props.notification || ''}
        autoHideDuration={3000}
        onRequestClose={() => { this.handleRequestClose(); }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app_snackbar/app_snackbar.jsx